/**
 * Ein Symbol je Ebene, damit eine Zielfrist im Kalender nicht wie eine
 * gewoehnliche Aufgabenfrist aussieht (Vorschlag zu F-09).
 */
import { FolderKanban, Gauge, GraduationCap, SquareCheck, Target, type LucideIcon } from 'lucide-react';

import type { DeadlineKind } from '@/domain/deadlines';

export const DEADLINE_ICON: Record<DeadlineKind, LucideIcon> = {
  aufgabe: SquareCheck,
  projekt: FolderKanban,
  ziel: Target,
  keyresult: Gauge,
  klausur: GraduationCap,
};
